import { render, staticRenderFns } from "./commitment-text.html?vue&type=template&id=9c71cc40&scoped=true&external"
import script from "./commitment-text.js?vue&type=script&lang=js&external"
export * from "./commitment-text.js?vue&type=script&lang=js&external"
import style0 from "./commitment-text.scss?vue&type=style&index=0&id=9c71cc40&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c71cc40",
  null
  
)

export default component.exports